import { errorMessage } from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
/**
 * PaymentViewModel owns the observable loading/error/success state around a
 * Stripe Payment Element confirmation. The actual `stripe.confirmPayment` call
 * must run in the View (it needs the client-only Stripe + Elements instances),
 * so it is injected as a thunk — mirroring BillingViewModel's injected redirect.
 */
export class PaymentViewModel extends ViewModel {
    constructor() {
        super({ status: "idle", error: null });
    }
    async confirm(confirmPayment) {
        this.setState({ status: "processing", error: null });
        try {
            const result = await confirmPayment();
            if (result.error) {
                this.setState({ status: "idle", error: result.error.message ?? "Payment failed." });
                return;
            }
            this.setState({ status: "succeeded", error: null });
        }
        catch (err) {
            this.setState({
                status: "idle",
                error: errorMessage(err, "Payment failed."),
            });
        }
    }
}
//# sourceMappingURL=PaymentViewModel.js.map